import { Box, Container, Typography, useMediaQuery, useTheme } from "@mui/material";
import { ButtonList } from "./button-list";
import { TypoEffect } from "./typo-effect";
import { useTranslation } from "next-i18next";
import Image from "next/image";
import React from "react";
export const FollowUs = ({ backgroundImageDesktop, backgroundImageMobile, facebook, instagram, sectionBackgroundImage, title, }) => {
    const theme = useTheme();
    const isAtLeastXl = useMediaQuery(theme.breakpoints.up("xl"));
    const { t } = useTranslation("c-common");
    return (React.createElement("aside", null,
        React.createElement(Box, { sx: {
                backgroundColor: theme.palette.background.default,
                position: "relative",
                width: "100&",
                "& .bg-image": { opacity: 0.3 },
            } },
            React.createElement(Image, { alt: t("follow-us", "Folge uns auf Social Media"), className: "bg-image", fill: true, placeholder: "blur", sizes: "100vw", src: sectionBackgroundImage, style: { objectFit: "cover", objectPosition: "bottom left" } }),
            React.createElement(Box, { sx: {
                    pb: { xs: 8, sm: 10, md: 12, xl: 16 },
                    position: "relative",
                    pt: { xs: 6, sm: 8, md: 10, xl: 14 },
                } },
                React.createElement(Container, null,
                    React.createElement(Typography, { component: "div", role: "heading", sx: { pt: 0, pb: 0, textAlign: "center" }, variant: isAtLeastXl ? "h1" : "h2" }, "Social Media"),
                    React.createElement(Box, { sx: {
                            margin: "0 auto",
                            maxWidth: { xs: "100%", sm: "75%", md: "65%", xl: "82%" },
                            pb: { xs: 8, xl: 12 },
                            pt: { xs: 6, lg: 8 },
                        } },
                        React.createElement(TypoEffect, { backgroundImageDesktop: backgroundImageDesktop, backgroundImageMobile: backgroundImageMobile, title: title })),
                    React.createElement(ButtonList, { facebook: facebook, instagram: instagram }))))));
};
//# sourceMappingURL=follow-us.js.map